<template>
  <div class="dashboard__view">
    <div class="page">
      <div class="page__title"></div>
    </div>

    <div class="overview">
      <div class="overview__item">
        <div class="overview__item__top">
          <div class="overview__item__left">
            <div class="overview__item__caption">Total amount recieved</div>
            <div class="overview__item__value">
              ₦ {{ formatAmount(overviewList.transaction_stats.total_value) }}
            </div>
          </div>
        </div>

        <div class="overview__item__bottom">
          <div class="overview__item__action">
            <router-link to="/dashboard/transactions?page=1"
              >View Transactions
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.20001 16V4"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 7.42857L5.2 4L8.4 7.42857"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.8 4V16"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6 12.5714L14.8 16L18 12.5714"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>
          </div>
        </div>
      </div>

      <div class="overview__item">
        <div class="overview__item__top">
          <div class="overview__item__left">
            <div class="overview__item__caption">Total customers</div>
            <div class="overview__item__value">
              {{ overviewList.vnuban_stats.total_volume | numberspace }}
            </div>
          </div>
        </div>
        <div class="overview__item__bottom">
          <div class="overview__item__action">
            <router-link to="/dashboard/customers?page=1"
              >View Customers
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.78136 3C7.60885 3 6.65503 4.04665 6.65503 5.33334C6.65503 6.62002 7.60883 7.66667 8.78136 7.66667C9.95389 7.66667 10.9077 6.61999 10.9077 5.33334C10.9077 4.04668 9.95389 3 8.78136 3ZM8.78136 6.99999C7.94421 6.99999 7.26257 6.25199 7.26257 5.33334C7.26257 4.41468 7.94421 3.66669 8.78136 3.66669C9.61851 3.66669 10.3001 4.41468 10.3001 5.33334C10.3001 6.25199 9.61854 6.99999 8.78136 6.99999Z"
                  fill="#e00b5b"
                />
                <path
                  d="M13.0342 5.66675C12.197 5.66675 11.5154 6.41475 11.5154 7.3334C11.5154 8.25206 12.197 9.00006 13.0342 9.00006C13.8713 9.00006 14.553 8.25206 14.553 7.3334C14.553 6.41475 13.8713 5.66675 13.0342 5.66675ZM13.0342 8.3334C12.5317 8.3334 12.1229 7.88475 12.1229 7.3334C12.1229 6.78206 12.5317 6.3334 13.0342 6.3334C13.5366 6.3334 13.9455 6.78206 13.9455 7.3334C13.9455 7.88475 13.5366 8.3334 13.0342 8.3334Z"
                  fill="#e00b5b"
                />
                <path
                  d="M4.57189 5.66675C3.73411 5.66675 3.0531 6.41475 3.0531 7.3334C3.0531 8.25206 3.73474 9.00006 4.57189 9.00006C5.40904 9.00006 6.09068 8.25206 6.09068 7.3334C6.09068 6.41475 5.40964 5.66675 4.57189 5.66675ZM4.57189 8.3334C4.06946 8.3334 3.66061 7.88475 3.66061 7.3334C3.66061 6.78206 4.06946 6.3334 4.57189 6.3334C5.07432 6.3334 5.48317 6.78206 5.48317 7.3334C5.48317 7.88475 5.07429 8.3334 4.57189 8.3334Z"
                  fill="#e00b5b"
                />
                <path
                  d="M8.78129 8.33337C6.60393 8.33337 4.8324 10.2774 4.8324 12.6667C4.8324 12.8507 4.96849 13 5.13617 13C5.30384 13 5.43994 12.8507 5.43994 12.6667C5.43994 10.6447 6.93868 9.00006 8.78129 9.00006C10.6239 9.00006 12.1226 10.6447 12.1226 12.6667C12.1226 12.8507 12.2587 13 12.4264 13C12.5941 13 12.7302 12.8507 12.7302 12.6667C12.7302 10.2774 10.9587 8.33337 8.78129 8.33337Z"
                  fill="#e00b5b"
                />
                <path
                  d="M13.034 9.66663C12.534 9.66663 12.0444 9.81663 11.6179 10.1C11.4751 10.196 11.4289 10.4006 11.5158 10.558C11.6039 10.7153 11.7898 10.7653 11.9332 10.67C12.2643 10.4493 12.6446 10.3333 13.034 10.3333C14.2065 10.3333 15.1604 11.3799 15.1604 12.6666C15.1604 12.8506 15.2965 13 15.4641 13C15.6318 13 15.7679 12.8506 15.7679 12.6666C15.7679 11.0126 14.5413 9.66663 13.034 9.66663Z"
                  fill="#e00b5b"
                />
                <path
                  d="M5.9443 10.0993C5.51842 9.81663 5.02877 9.66663 4.52877 9.66663C3.02151 9.66663 1.79492 11.0126 1.79492 12.6666C1.79492 12.8506 1.93102 13 2.09869 13C2.26637 13 2.40246 12.8506 2.40246 12.6666C2.40243 11.3799 3.35626 10.3333 4.52877 10.3333C4.9182 10.3333 5.29848 10.4493 5.62899 10.6693C5.77175 10.7646 5.95888 10.7146 6.04636 10.5573C6.13384 10.3999 6.08765 10.1953 5.9443 10.0993Z"
                  fill="#e00b5b"
                />
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="tab">
        <div
          :class="{ active: tabSelected == 'pending' }"
          @click="switchView('pending')"
          class="tab__item"
        >
          Customers
        </div>
        <div
          :class="{ active: tabSelected == 'transaction' }"
          @click="switchView('transaction')"
          class="tab__item"
        >
          Transactions
        </div>
      </div>

      <div class="tab__content" v-if="tabSelected == 'pending'">
        <EmptyState  v-if="pendingEmptyState" type="customer" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="customerloading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>CUSTOMER</th>
                <th>PHONE</th>
                <th>NUBAN</th>
                <th>REFERENCE</th>
                <th style="text-align: left">CREATED</th>
              </tr>
            </thead>
            <tbody>
              <router-link
                :key="item.unique_reference"
                :to="{ name: 'customers-details', params: { id: item.vnuban } }"
                tag="tr"
                v-for="item in pendingCustomers"
              >
                <td>
                  <span class="name">{{ item.account_name }}</span>
                  <span class="email">{{ item.account_email }}</span>
                </td>
                <td>{{ item.account_mobile_number }}</td>
                <td>{{ item.vnuban }}</td>
                <td>{{ item.account_reference }}</td>
                <td style="text-align: left">
                  {{ moment(item.created_at).format("llll") }}
                </td>
              </router-link>
            </tbody>
          </table>
          <router-link
            class="table__action"
            tag="div"
            to="/dashboard/customers?status=inactive&page=1"
            >View All Pending Customers</router-link
          >
        </div>
      </div>

      <div class="tab__content" v-if="tabSelected == 'transaction'">

        <EmptyState  v-if="completedEmptyState" type="transaction" />
        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="transactionloading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>REFERENCE</th>
                <th>AMOUNT</th>
                <th>VNUBAN</th>
                <th>SOURCE</th>
                <th style="text-align: left">PAYMENT DATE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :key="item.unique_reference"
                @click="goTo(item)"
                v-for="item in completedTransactions"
              >
                <td style="max-width: 140px !important; word-break: break-all">
                  <span class="name">{{ item.unique_reference }}</span>
                </td>
                <td>{{ item.currency }} {{ item.amount | money }}</td>
                <td>{{ item.nuban || "N/A" }}</td>
                <td>{{ item.source_bank_code }} - {{ item.source_nuban }}</td>
                <td style="text-align: left">
                  {{ moment(item.created_at).format("llll") }}
                </td>
              </tr>
            </tbody>
          </table>
          <router-link
            class="table__action"
            tag="div"
            to="/dashboard/transactions?page=1"
            >View All Transactions</router-link
          >
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import emptyTransactions from "../../../components/emptytransactions";
import { formatAmount } from "../../../lib/formatAmount";
import Modal from "../../../components/modal";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Overview",
  },

  components: {
    emptyTransactions,
    Modal,EmptyState
  },
  data() {
    return {
      showModal: false,
      styleClass: "",
      specificTransaction: {},
      specificAudit: [],
      formatAmount,
      overviewList: {
        transaction_stats: {
          total_value: 0,
          total_volume: 0,
        },
        vnuban_stats: {
          total: 0,
          total_pending: 0,
          total_received: 0,
        },
      },
      totalPendingAmount: 0,
      pendingCustomers: {},
      completedTransactions: {},
      customerloading: true,
      transactionloading: true,
      pendingEmptyState: false,
      completedEmptyState: false,
      tabSelected: "pending",
    };
  },

  methods: {
    moment: window.moment,
    fetchAudit(value) {
      this.$http
        .get(`dashboard/audits?entity_id=${value}&entity_type=transaction`)
        .then((response) => {
          this.specificAudit = response.body.data.audits;
        });
    },
    goTo(item) {
      this.$router.push({
        name: "transaction-details",
        params: { id: item.unique_reference },
      });
    },
    async toggleModal(item) {
      await this.fetchAudit(item.unique_reference);
      this.specificTransaction = item;
      this.showModal = !this.showModal;
      this.styleClass =
        this.styleClass === "display: block"
          ? "display: none !important"
          : "display: block";
    },
    // Fetch Overview
    fetchStats() {
      let appendedQuery = "";
      // check for mode to append query
      if (this.mode) {
        appendedQuery = "";
      } else {
        appendedQuery = "?is_test=1";
      }
      this.$http
        .get(`admin/merchants/overview${appendedQuery}`)
        .then((response) => {
          if (response.body.data.transaction_stats !== null) {
            this.overviewList.transaction_stats =
              response.body.data.transaction_stats;
          }
          if (response.body.data.vnuban_stats !== null) {
            this.overviewList.vnuban_stats = response.body.data.vnuban_stats;
            // this.totalPendingAmount = response.body.data.vnuban_stats.total_value;
          }
        });
    },
    // Fetch Vnuban stats
    // This contains pending and received values
    fetchVnubanStats() {
      this.$http.get("admin/vnubans_payment_stats").then((response) => {
        if (response.body.data !== null) {
          // merge response with overview
          this.overviewList.vnuban_stats = response.body.data;
        }
      });
    },

    fetchcustomers() {
      this.$http
        .get(`admin/vnubans?pending_status=pending`)
        .then((response) => {
          if (response.body.data.vnubans.length > 0) {
            this.pendingCustomers = response.body.data.vnubans;
            this.customerloading = false;
            this.pendingEmptyState = false;
          } else {
            this.pendingEmptyState = true;
            this.customerloading = false;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },

    fetchTransactions() {
      this.$http
        .get(`admin/transactions?`)
        .then((response) => {
          if (response.body.data.transactions.length > 0) {
            this.completedTransactions = response.body.data.transactions;
            this.transactionloading = false;
            this.completedEmptyState = false;
          } else {
            this.completedEmptyState = true;
            this.transactionloading = false;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },

    triggerModal(value) {
      this.$router.push({
        path: `/dashboard/customers?page=1&triggerModal=${value}`,
      });
    },

    switchView(value) {
      if (value == "pending") {
        this.tabSelected = "pending";
      } else if (value == "transaction") {
        this.tabSelected = "transaction";
      }
    },
  },
  computed: {
    mode() {
      return this.$store.state.mode;
    },
  },

  async created() {
    await this.fetchStats();
    // await this.fetchVnubanStats();
    await this.fetchcustomers();
    await this.fetchTransactions();
  },
};
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  margin-bottom: 32px;
  &__item {
    background: #ffffff;
    box-sizing: border-box;
    box-shadow: 0px 8px 10px rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    flex-basis: 50%;
    text-align: center;
    &:last-child {
      margin-left: 32px;
    }

    &__top {
      padding: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &__bottom {
      padding: 27px 24px 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-top: 1px solid #ebf0f4;
    }

    &__value {
      font-size: 36px;
      line-height: 43px;
      margin-bottom: 13px;
    }

    &__caption {
      color: rgba(38, 25, 64, 0.7);
      font-size: 14px;
      margin-bottom: 15px;
    }

    &__action {
      color: #e00b5b;
      a {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 14px;
        /* identical to box height, or 87% */

        color: #e00b5b;
        text-decoration: none;
        text-transform: capitalize;
      }

      svg {
        margin-top: -10px;
        display: inline-block;
      }
    }

    &__number {
      color: rgba(38, 25, 64, 0.7);
    }
  }
}

.orange {
  color: #f8a061;
}

.name {
  color: #261940;
  display: block;
  margin-bottom: 4px;
}

.email {
  color: rgba(38, 25, 64, 0.6);
  font-size: 12px;
}
</style>

<style lang="scss">
.page {
  z-index: 1000 !important;
}
.tag.no-bg {
  padding: 0 !important;
}
.sudo-transactions-details {
  max-width: 520px;
  max-height: 80vh;
  width: 100% !important;
  height: 80vh;
  padding: 0;
  .modal {
    height: 80vh;
    padding: 0;
    display: block !important;
  }
  .drop-down {
    width: 100%;
  }

  .left {
    max-width: 55%;
    flex: 1;
    padding: 10px;
    overflow: auto;
  }
  .right {
    max-width: 45%;
    width: 400px;
    flex: 0.5;
    background: #f5f5f7;
    border-radius: 6px;
    text-align: left;
    padding: 10px;
    margin: 40px;

    .audit-title {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 22px;
      padding: 10px 15px;

      color: #000000;
    }
    .audit-box {
      padding: 15px;
      border-bottom: 1px solid #ebf0f4;
    }
    .audit-type {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: rgba(0, 0, 0, 0.7);
    }
    .audit-date {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      color: rgba(38, 25, 64, 0.6);
    }
  }
  &.modal-content,
  &__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #ffffff !important;
    border-radius: 10px 10px 0px 0px;
    max-width: 90%;
    width: 100% !important;
    height: 100%;
    margin: auto;
    text-align: center;
    padding: 15px 0;
    &__transaction_item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #ebf0f4;
      padding: 20px 0;

      &__top {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.5);
        padding: 10px 0;
      }
      &__info {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        color: #261940;
      }
    }
  }
  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #000000; //comment added to redeploy
  }
}
</style>